"use client";

import { useEffect } from "react";
import { StatusPage } from "@/components/pages/StatusPage";
import { getStatusCopy } from "@/lib/status-copy";

const copy = getStatusCopy("ar", "error");

export default function ArError({
  error,
  reset,
  retry,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  retry?: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <StatusPage copy={copy} onReset={retry ?? reset} />;
}
